type BillingPlanControlsInput = {
  role: string | undefined;
  subscriptionCost: number | undefined;
  hasSubscriptionMismatch: boolean;
  hasStripeSubscription: boolean;
  cancellationScheduled: boolean;
  hasCancellationPlan: boolean;
};

export function getBillingPlanControls(input: BillingPlanControlsInput) {
  const canManage =
    !input.hasSubscriptionMismatch && input.role === "owner";
  const isStartingPaidSubscription =
    input.subscriptionCost === undefined || input.subscriptionCost === 0;
  const canCancelSubscription =
    canManage &&
    !isStartingPaidSubscription &&
    !input.cancellationScheduled &&
    input.hasStripeSubscription &&
    input.hasCancellationPlan;
  const canResumeSubscription =
    canManage &&
    !isStartingPaidSubscription &&
    input.cancellationScheduled &&
    input.hasStripeSubscription;

  return {
    canChangePlan: canManage,
    canCancelSubscription,
    canResumeSubscription,
    isStartingPaidSubscription,
    changePlanLabel:
      input.subscriptionCost === undefined
        ? "Choose a plan"
        : isStartingPaidSubscription
          ? "Upgrade"
          : "Change plan",
  } as const;
}
